 
 
 
 
 
 
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'addresses');
    };
});



// WEBPACK FOOTER //
// ./model/reverseGeocode/reverseGeocode.js